import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './PdpSharedCarouselDot.scss';

function PdpSharedCarouselDot({ isActive, onClick }) {
    return (
        <span
            className={classNames(styles.dot, {
                [styles.activeDot]: isActive,
            })}
            onClick={onClick}
        />
    );
}

PdpSharedCarouselDot.propTypes = {
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
};

PdpSharedCarouselDot.defaultProps = {
    isActive: false,
    onClick: () => {},
};

export { PdpSharedCarouselDot };
